import { useaxios } from "../../../utils/useaxios";
export default (company_id, company_name, company_address, company_phone) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('company/update.php', { company_id, company_name, company_address, company_phone }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}